<template>
	<div class="grow flex items-center gap-2">
		<Dropdown :id="`${id}-dropdown`">
			<template #button>
				<button type="button" class="input-like">
					<span class="flex items-center gap-2">
						<CountryFlag :iso="selectedPhoneCountry.code" mode="rounded"/>
						<span>{{ selectedPhoneCountry.code }} +{{ selectedPhoneCountry.phone_code }}</span>
					</span>
				</button>
			</template>
			<LabeledObject full>
				<template #label>{{ trans('general.search') }}</template>
				<input v-model="filter" type="text" class="w-full">
			</LabeledObject>
			<DropdownItem v-for="country in filteredPhoneCountries" :key="`${id}-${country.code}-dropdown-item`" @click.stop="selectPhoneCountry(country)">
				<div class="grow flex items-center gap-4">
					<CountryFlag :iso="country.code" mode="rounded"/>
					<div class="grow flex flex-col items-start">
						<p class="text-xs text-gray-600 dark:text-gray-400">{{ country.name }}</p>
						<p class="font-bold">+{{ country.phone_code }}</p>
					</div>
				</div>
			</DropdownItem>
		</Dropdown>
		<input v-model="phone" type="tel" class="grow" @change.stop="emit('update:phone', phone)">
	</div>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import {type Country} from '@/Types/Country'
import {closeAllDropdownLists} from '@/Helpers/general'
import Dropdown from '@/Components/UI/Dropdown/Dropdown.vue'
import CountryFlag from '@dzangolab/vue-country-flag-icon'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import DropdownItem from '@/Components/UI/Dropdown/DropdownItem.vue'
import {computed, type ComputedRef, defineEmits, defineProps, ref, type Ref} from 'vue'

const props = defineProps<{
	id:string,
	code:string,
	phone:string,
	countries:Array<Country>,
}>()

const emit = defineEmits([
	'update:code',
	'update:phone',
])

const code:Ref<string> = ref(props.code)
const phone:Ref<string> = ref(props.phone)
const filter:Ref<string> = ref('')
const countries:Ref<Array<Country>> = ref(props.countries)

const filteredPhoneCountries:ComputedRef<Array<Country>> = computed(():Array<Country> => {
	if(filter.value.trim().length === 0){
		return []
	}
	return countries.value.filter((c:Country) => c.name.toLowerCase().startsWith(filter.value.toLowerCase()) || c.phone_code.startsWith(filter.value))
})

const selectedPhoneCountry:ComputedRef<Country|undefined> = computed(():Country|undefined => {
	return countries.value.find((c:Country) => c.code === code.value)
})

function selectPhoneCountry(country:Country):void{
	code.value = country.code
	emit('update:code', code.value)
	filter.value = ''
	closeAllDropdownLists()
}
</script>